import { useTheme } from "next-themes";
import { Toaster as Sonner, toast } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      position="bottom-center"
      toastOptions={{
        classNames: {
          // Icarus D&D: Toast = dunkle Pill, unten zentriert, 12px Radius
          toast:
            "group toast group-[.toaster]:rounded-xl group-[.toaster]:border-none group-[.toaster]:bg-[oklch(0.25_0.02_250)] group-[.toaster]:text-white group-[.toaster]:shadow-[0_18px_44px_-14px_oklch(0.2_0.03_250/0.6)]",
          description: "group-[.toast]:text-[oklch(0.8_0.015_250)]",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton: "group-[.toast]:bg-white/10 group-[.toast]:text-white",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
